import type { CipherText, FulfillRequest } from "@b2bportal/purchase-api";

import { scheduleFulfill } from "@hopper-b2b/api";
import { CartFulfillErrorModal } from "@hopper-b2b/checkout";

import type { FlightMachineContext } from "../../../types";

import { getFullFillRequestParams } from "../selectors";

export const scheduleFulfillService = (
  context: FlightMachineContext,
  _event: unknown
) =>
  new Promise((resolve, reject) => {
    const fulfillRequest: FulfillRequest = getFullFillRequestParams({
      context,
    });
    scheduleFulfill(fulfillRequest)
      .then((result: CipherText) => {
        if (result.value) {
          resolve(result);
        } else {
          reject({
            type: CartFulfillErrorModal.NoCipherText,
          });
        }
      })
      .catch((e) => {
        reject({
          type: CartFulfillErrorModal.NoCipherText,
        });
      });
  });
